/** Whether what the views show is the daemon cache's mail as last synced
 *  because Outlook is not answering (2026-10-02). Every list and count
 *  answer says where it came from (X-WOV-Source, X-WOV-Cache-Age-Ms,
 *  X-WOV-Stale); bridgeFetch reports them here and the banner listens. */

type State = { stale: boolean; syncedAt: number | null; seenAt: number };

let state: State = { stale: false, syncedAt: null, seenAt: 0 };
const listeners = new Set<(s: State) => void>();

export function noteCacheHeaders(h: Headers): void {
  if (h.get("X-WOV-Source") !== "cache") return;
  const stale = h.get("X-WOV-Stale") === "1";
  const age = Number(h.get("X-WOV-Cache-Age-Ms"));
  const next: State = stale
    ? { stale: true, syncedAt: Number.isFinite(age) ? Date.now() - age : state.syncedAt, seenAt: Date.now() }
    : { stale: false, syncedAt: null, seenAt: Date.now() };
  if (next.stale === state.stale && (!next.stale || Math.abs((next.syncedAt ?? 0) - (state.syncedAt ?? 0)) < 30_000)) {
    state = next;
    return;
  }
  state = next;
  for (const l of listeners) l(state);
}

export function getCacheState(): State {
  return state;
}

export function onCacheState(fn: (s: State) => void): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
